export class ColorScheme
{
  static readonly black_transparent = 'rgba(0, 0, 0, 0.5)'
  static readonly black_transparent_80 = 'rgba(0, 0, 0, 0.8)'
  static readonly black_transparent_30    = 'rgba(0, 0, 0, 0.3)'

  static readonly red = '#ff0000';
  static readonly normal_green = '#00ff00';
  static readonly blue = '#0000ff';
  static readonly difficulty_yellow = '#ffff00';
  static readonly cream = '#fffdd0';
  static readonly black = '#000000';
  static readonly white = '#ffffff';
  static readonly white_70 = 'rgba(255, 255, 255, 0.7)';

  static readonly menu_button_outline = "#1B750D"
  static readonly menu_button_outline_hard = "#5A0D75"
  static readonly menu_button_outline_superhard = "#9A0930"
  static readonly menu_button_hard = "#80470F"
  static readonly footer_text_outline = "#27315D"
  static readonly navigation_text_outline = "#2A1F8F"

  static readonly red_btn_outline = "#880615"
  static readonly orange_btn_outline = "#8A4A08"
  static readonly cyan_btn_outline = "#08546E"
  static readonly purple_btn_outline = "#5A0D75"
  static readonly gray_btn_outline = "#4B4B4B"
  static readonly flat_blue_btn_outline = "#0A4C8C"
  static readonly flat_light_blue_btn_outline = "#0B6A8A"
  static readonly flat_orange_btn_outline = "#9A4A08"
  static readonly league_text = "#BADFFF"
  static readonly tap_zone_bg = 'rgba(0, 0, 0, 0.2)'

  static readonly dialog_title = "#FFF785"
  static readonly dialog_title_outline = "#0C2A53"
  static readonly dialog_continue_outline = "#076D25"
  static readonly dialog_ad_outline = "#2A548A"
  static readonly text_xp_boost = "#FFFA72"

  static readonly dialog_music_item_bg = "#246080"
  static readonly dialog_music_item_bg_active = "#327173"
  static readonly dialog_music_item_circle = "rgba(36, 46, 73, 0.8)"

  static readonly garage_title_bg = "#2788AB"
  static readonly garage_title_outline = "#082858"
  static readonly garage_title_line = "#80D0ED"
  static readonly garage_list_bg = "#19597B"
  
  static readonly garage_card_bg = "#63BDE5"
  static readonly garage_card_outline = "#0E1F46"
  static readonly garage_card_title = "#4DA7CF"
  static readonly garage_card_shadow = "rgba(0, 0, 0, 0.25)"
  static readonly garage_card_button = "#0080C5"
  static readonly garage_card_bg_active = "#FED84C"
  static readonly garage_card_title_active = "#E6AC3F"
  static readonly garage_green = "#10FF40"

  static readonly calendar_dialog_bg = "#916BEE"
  static readonly calendar_item_text_outline = "#285A84"
  static readonly calendar_item_text_outline_current = "#88640F"

  static readonly game_bg_color = "rgba(20, 58, 72, 0.75)"

  static readonly tooltip_title = "#813E04"
  static readonly tooltip_text = "#0C384F"

  static readonly switch_bg_checked = "#1EC123"
  static readonly switch_bg_unchecked = "#CB2B2B"
  static readonly switch_circle = "#FFFEE5"
  static readonly switch_circle_outline = "#E09753"

  static readonly profile_info_text = "#707070";

  static readonly menu_top_el_text = "#003F87"
  
  static readonly game_block_text = "#27098D"

  static readonly shop_title_text = "#EEE6A2"
  static readonly shop_title_inner_outline = "#641B00"
  static readonly shop_amount_outline = "#573325"
  static readonly shop_title_outline = "#0E144A"

  // Settings screen (from XD mockup, artboard "Web 1920 – 7")
  static readonly settings_bg = "#173A98"

  static readonly settings_header_top = "#1052FF"
  static readonly settings_header_bottom = "#0A3EC7"
  static readonly settings_header_stripe = "#FDE127"

  static readonly settings_title_bg = "#173A98"
  static readonly settings_title_outline = "#3266D4"

  // Settings dialog (redone from screen -> dialog, new XD spec)
  static readonly settings_dialog_title_outline = "#05267E"
  static readonly leave_level_text_outline = "#153997"

  static readonly settings_card_border_top = "#608CFF"
  static readonly settings_card_border_bottom = "#00227D"
  static readonly settings_card_fill_top = "#2658DC"
  static readonly settings_card_fill_bottom = "#1748C9"

  static readonly settings_icon_bg = "#1748C9"

  static readonly settings_toggle_track = "#0432A8"
  static readonly settings_toggle_knob = "#FFFEE5"
  static readonly settings_toggle_on = "#21D12D"
  static readonly settings_toggle_off = "#FF0000"

  static readonly settings_support_border = "#51D31C"
  static readonly settings_support_top = "#80D800"
  static readonly settings_support_bottom = "#479800"
  static readonly settings_support_rim_top = "#0189B4"
  static readonly settings_support_rim_mid = "#0BB0C7"
  static readonly settings_support_rim_bottom = "#2AE7FE"

  static readonly settings_link_btn = "#302CB2"
  static readonly settings_dialog_divider = "#302CB2"

  // Avatars
  static readonly avatar_stroke           = "#E5A87C"

  // Leaderboard (ported from PicPix)
  static readonly leaderboard_bg                   = "#375090"
  static readonly leaderboard_title                = "#FFF085"
  static readonly leaderboard_title_gradient_from  = "#FFF7AD"
  static readonly leaderboard_title_gradient_to    = "#FFEB69"
  static readonly leaderboard_title_outline        = "#E16727"
  static readonly leaderboard_content_bg           = "#2A4386"
  static readonly leaderboard_content_bg_substrate = "#365194"
  static readonly leaderboard_avatar_bg            = "#769CE9"
  static readonly leaderboard_tab_text_inactive    = "#B9BFD3"
  static readonly leaderboard_tabs_line            = "#5B78C9"
  static readonly leaderboard_bottom_line          = "#4263BB"
  static readonly leaderboard_tab_border           = "#B04F4F"
  static readonly leaderboard_tab_fill             = "#72023A"
  static readonly leaderboard_separator_line       = "#F5E7B5"
  static readonly leaderboard_content_bg_dark      = "#3E0B1E"
  static readonly leaderboard_bg_gradient_from     = "#870249"
  static readonly leaderboard_bg_gradient_to       = "#B70649"
  static readonly leaderboard_title_text           = "#FAF2A6"
  static readonly leaderboard_title_gradient_btm   = "#B84D43"
  static readonly leaderboard_player_avatar_bg     = "#FEFFE7"
  static readonly leaderboard_score_text           = "#FFFCA7"
  static readonly leaderboard_bg_solid             = "#0e4df1"
  static readonly leaderboard_content_backdrop     = "#052888"
  static readonly leaderboard_screen_background    = "#062E97"
  static readonly leaderboard_screen_bg            = "#1A176E"
  static readonly leaderboard_card_name            = "#700303"
  static readonly leaderboard_card_outline         = "#700303"

  // ContinueOverlay
  static readonly continue_overlay_caption_outline = "#295D97"
  static readonly tooltip_text_outline = "#772ACF"
  static readonly continue_overlay_card_text = "#6E0000"

  // BuyFireworksDialog
  static readonly fireworks_dialog_title_outline = "#3265D2"
  static readonly booster_dialog_title_outline = "#103A92"
  static readonly booster_dialog_quantity_outline = "#07226A"

  // LevelBoxDialog
  static readonly level_box_info_bg = "#302CB2"
  static readonly level_box_info_accent = "#F8BE01"

  // MoreLivesDialog
  static readonly more_lives_badge_circle = "#F4E7D4"

  static readonly test_button_bg = "#FF5A5F"

  static readonly play_dialog_difficulty_label_outline = "#00346E"

  // Tutorial
  static readonly tutorial_text = "#2F4B87"
  static readonly tutorial_spotlight_clear = "rgba(0, 0, 0, 0)"
  static readonly tutorial_spotlight_dim = "rgba(0, 0, 0, 0.82)"

  // GameResultOverlay (x2 reward state)
  static readonly result_reward_x2_text = "#FFF88E"



  static readonly hearts_timer_bg = "#D9873B"
  static readonly hearts_text = "#700303"
  static readonly hearts_ask_button = "#75260D"

  static readonly widget_claim = "#006E12"
  static readonly widget_time = "#00166E"
  static readonly daily_card_title_1 = "#AA6600"
  static readonly daily_card_title_2 = "#E95600"
  static readonly daily_card_title_3 = "#4A0224"
  static readonly daily_card_button_outline = "#4B4B4B"
  static readonly daily_card_reward_outline = "#02091C"

  static readonly friends_title_outline = "#02091C"
  static readonly friends_tab_outline = "#2F0A7A"
  static readonly friends_card_name = "#7C1F17"
  static readonly friends_card_counter_outline = "#5A3110"
  static readonly friends_card_button_outline = "#8A4A08"
  static readonly friends_card_status = "#0C5878"
  static readonly friends_remind_outline = "#08546E"
  static readonly friends_invite_reward = "#FFE924"
  static readonly friends_invite_reward_outline = "#0F186A"

  static readonly leaderboard_title_1 = "#6C1F04"
  static readonly leaderboard_title_2 = "#F9AF26"
  static readonly leaderboard_title_3 = "#4A0224"
  static readonly leaderboard_title_4 = "#E95600"
  static readonly leaderboard_title_5 = "#AA6600"

  static readonly daily_card_reward_timer_border = "#FFD500"
  static readonly daily_card_reward_timer_shadow = "rgba(29, 0, 0, 0.74)"

  static readonly invite_friend_text_outline = "#151F77"

  static readonly conveyor_result_outline = "#05267E"
  static readonly conveyor_result_return_outline = "#0B6A8A"
  static readonly conveyor_result_title = "#FFE45C"
  static readonly conveyor_result_shadow = "rgba(16, 6, 84, 0.43)"
  static readonly conveyor_result_value_top = "#FFFBD6"
  static readonly conveyor_result_value_bottom = "#FFD23F"
  static readonly conveyor_hud_text_outline = "#1E4A9A"
  static readonly conveyor_hud_time_final = "#FFE45C"

  static readonly happy_fall_board_fill = "#13234A"
  static readonly happy_fall_peg = "#F9DB6A"
  static readonly happy_fall_ball_shadow = "rgba(20, 8, 0, 0.7)"
  static readonly happy_fall_ball_shadow_edge = "rgba(20, 8, 0, 0)"
  static readonly happy_fall_value_outline = "#2B1D0E"
  static readonly happy_fall_reward = "#FFE45C"
  static readonly happy_fall_intro_bg = "#4844D4"
  static readonly happy_fall_wait_title_outline = "#0B2A57"
  static readonly happy_fall_timer_fill = "#C9864A"
  static readonly happy_fall_timer_border = "#F6C51D"
  static readonly happy_fall_timer_clock = "#D7853D"
  static readonly happy_fall_timer_outline = "#5A1409"

  static readonly first_steps_subtitle_outline = "#1C0F33"
  static readonly first_steps_subtitle_highlight = "#FFE81F"
  static readonly first_steps_task_title = "#6B1A2C"
  static readonly first_steps_value_outline = "#3A1220"
  static readonly first_steps_button_outline = "#2A6E0C"
  static readonly first_steps_done_outline = "#FFFFFF"
  static readonly first_steps_chest_dim = "rgba(0, 0, 0, 0.7)"
}
